// extracted by mini-css-extract-plugin
export default {"base":"vp_j1xTE","cookie-consent-in":"vp_hMyK_","content":"vp_gwh8V","buttons":"vp_R3BDe","accept":"vp_NEhvC","decline":"vp_t2MIi"};